import { render, staticRenderFns } from "./LahanSelected.vue?vue&type=template&id=3500fba2"
import script from "./LahanSelected.vue?vue&type=script&lang=js"
export * from "./LahanSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports